import _ from 'lodash'
import { DASH } from 'modules/constants'
import formatPrice from 'modules/utils/numbers/formatPrice'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Card } from 'views/components/Card/Card'
import { CompanyLink } from 'views/components/CompanyLink/CompanyLink'
import { KeyValue } from 'views/components/KeyValue/KeyValue'
import { useDealContext } from './DealContext'
import { defaultTheme, Text } from '@agro-club/agroclub-shared'
import { useMediaQuery } from 'react-responsive'

const StyledCardContainer = styled(Card.Container)`
  padding: 12px 16px;
  margin-top: -14px;

  @media (max-width: ${defaultTheme.queries.mobile}) {
    margin-top: 0;
    border: 1px solid ${defaultTheme.color.secondary100};
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;

  @media (max-width: ${defaultTheme.queries.mobile}) {
    flex-direction: column;
    gap: 4px;
  }
`

const TitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  @media (max-width: ${defaultTheme.queries.mobile}) {
    flex-direction: column;
  }
`

const noShrink = { style: { flexShrink: 0 } }
const formatValue = (value: number | null) => {
  return !_.isNil(value) ? formatPrice(value, true, false) : DASH
}

export const BuyerFinStatus = () => {
  const { t } = useTranslation('deal')
  const { deal } = useDealContext()
  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })
  const availableColor =
    deal.available_credit_limit && deal.available_credit_limit < 0 ? 'accentDestruct600' : undefined

  return (
    <>
      <StyledCardContainer intent="backgroundPrimary" bordered>
        <Card.GapableContent>
          <TitleWrapper>
            <Card.Title>{t('BuyerFinancialStatus')}</Card.Title> <CompanyLink company={deal.purchase_bid.company} />
          </TitleWrapper>
          <Wrapper>
            <KeyValue label={t('paymentDelayDays')} {...noShrink}>
              {deal.payment_delay_days}
            </KeyValue>
            <KeyValue label={t('creditLimit')} {...noShrink}>
              {formatValue(deal.credit_limit)}
              <Text typography="bodySmall" color="secondary" style={!isMobile ? { maxWidth: '130px' } : {}}>
                {deal.credit_limit_comment}
              </Text>
            </KeyValue>
            <KeyValue label={t('accountsReceivable')} {...noShrink}>
              {formatValue(deal.debt)}
            </KeyValue>
            <KeyValue label={t('signedQuantity')} {...noShrink}>
              {formatValue(deal.remaining_signed_margin)}
            </KeyValue>
            <KeyValue label={t('availableCredit')} {...noShrink}>
              <Text color={availableColor}>{formatValue(deal.available_credit_limit)}</Text>
            </KeyValue>
          </Wrapper>
        </Card.GapableContent>
      </StyledCardContainer>
    </>
  )
}
